import React from 'react'

import './styles/TelegramBots.scss'
import { publicConfiguration } from '../../config'

const telegramEmailSubject = 'Telegram-%D0%B1%D0%BE%D1%82%20%D0%B4%D0%BB%D1%8F%20%D0%B1%D0%B8%D0%B7%D0%BD%D0%B5%D1%81%D0%B0';
const telegramEmailUrl = `mailto:${publicConfiguration.supportEmail}?subject=${telegramEmailSubject}`;

const botTypes = [
    {
        icon: 'support',
        title: 'Поддержка и сервис',
        text: 'Отвечает на типовые вопросы, собирает контекст обращения и передаёт сложный диалог специалисту.',
        tags: ['FAQ и база знаний', 'Маршрутизация', 'Связь с оператором']
    },
    {
        icon: 'sales',
        title: 'Продажи и заявки',
        text: 'Проводит короткий бриф, квалифицирует запрос и передаёт структурированную заявку в рабочую систему.',
        tags: ['Квиз-сценарий', 'Лид в CRM', 'Уведомление команды']
    },
    {
        icon: 'calendar',
        title: 'Запись и бронирование',
        text: 'Показывает доступные варианты, собирает данные и синхронизирует подтверждённую запись с календарём.',
        tags: ['Слоты', 'Напоминания', 'Перенос записи']
    },
    {
        icon: 'store',
        title: 'Каталог и заказы',
        text: 'Помогает выбрать услугу или товар, уточняет параметры и создаёт заказ через согласованный backend.',
        tags: ['Каталог', 'Статус заказа', 'Оплата по правилам платформы']
    },
    {
        icon: 'team',
        title: 'Внутренние процессы',
        text: 'Автоматизирует запросы сотрудников, согласования, отчёты и уведомления в закрытом рабочем контуре.',
        tags: ['Роли и доступ', 'Регламенты', 'Служебные команды']
    },
    {
        icon: 'broadcast',
        title: 'Сообщество и лояльность',
        text: 'Проводит onboarding, управляет доступом и подписками, помогает возвращать аудиторию полезными сценариями.',
        tags: ['Onboarding', 'Доступ и подписки', 'Лояльность']
    }
]

const aiCapabilities = [
    {
        number: '01',
        title: 'Понимание запроса',
        text: 'Классификация темы и намерения пользователя по согласованному набору сценариев.'
    },
    {
        number: '02',
        title: 'Ответ по вашим данным',
        text: 'Поиск ответа в утверждённой базе знаний с ограничением источников и понятным fallback.'
    },
    {
        number: '03',
        title: 'Текст, голос и документы',
        text: 'Извлечение согласованных данных из сообщения или файла в поля заявки, задачи или карточки клиента.'
    },
    {
        number: '04',
        title: 'Резюме для команды',
        text: 'Краткая сводка диалога перед передачей менеджеру — без необходимости перечитывать всю переписку.'
    }
]

const businessOutcomes = [
    {
        number: '01',
        title: 'Принимает обращение',
        text: 'Фиксирует запрос и нужный контекст, пока сервис доступен пользователю.'
    },
    {
        number: '02',
        title: 'Уточняет задачу',
        text: 'Задаёт только необходимые вопросы по заранее согласованному сценарию.'
    },
    {
        number: '03',
        title: 'Запускает действие',
        text: 'Создаёт запись, заказ, заявку или другую операцию через подключённый backend.'
    },
    {
        number: '04',
        title: 'Передаёт команде',
        text: 'Отправляет структурированные данные менеджеру, CRM или helpdesk.'
    }
]

const integrations = [
    ['CRM', 'amoCRM, Битрикс24 или ваш API'],
    ['Данные', 'PostgreSQL, каталог, учётная система'],
    ['Команда', 'Helpdesk, почта, рабочие Telegram-чаты'],
    ['Расписание', 'Календари и сервисы бронирования'],
    ['Оплата', 'Telegram Payments и Stars по правилам платформы или допустимый провайдер'],
    ['Аналитика', 'События, воронка, экспорт и webhooks']
]

const processSteps = [
    {
        stage: 'Исследование',
        title: 'Разбираем процесс',
        text: 'Фиксируем роли, точки входа, частые запросы, исключения и критерии успешного сценария.'
    },
    {
        stage: 'Прототип',
        title: 'Проектируем диалоги',
        text: 'Собираем карту состояний и показываем кликабельный сценарий до основной разработки.'
    },
    {
        stage: 'Разработка',
        title: 'Подключаем бизнес-логику',
        text: 'Реализуем команды, хранение состояния, интеграции, права доступа и административный контур.'
    },
    {
        stage: 'Проверка и запуск',
        title: 'Тестируем и разворачиваем',
        text: 'Проверяем ошибки, повторы, мобильный UX и handoff, затем настраиваем health-check, безопасные логи и обновления.'
    }
]

const safeguards = [
    'Минимально необходимый объём персональных данных',
    'Разделение пользовательских и административных команд',
    'Дедупликация событий и защита от частых запросов',
    'Секреты только в защищённом окружении, не в коде',
    'Проверяемые health-check и корректное завершение процесса',
    'Переход к человеку там, где автоматизация не должна решать за бизнес'
]

function Icon({ name }) {
    const paths = {
        support: (
            <React.Fragment>
                <path d="M5 11a7 7 0 0 1 14 0v5a3 3 0 0 1-3 3h-2"/>
                <path d="M5 16H3v-5h2m14 5h2v-5h-2M9 20h5"/>
            </React.Fragment>
        ),
        sales: (
            <React.Fragment>
                <path d="M4 19V9l8-5 8 5v10"/>
                <path d="M8 19v-5h8v5M9 9h6"/>
            </React.Fragment>
        ),
        calendar: (
            <React.Fragment>
                <rect x="3" y="5" width="18" height="16" rx="2"/>
                <path d="M8 3v4m8-4v4M3 10h18m-13 4h3m2 0h3m-8 3h3"/>
            </React.Fragment>
        ),
        store: (
            <React.Fragment>
                <path d="M4 10v10h16V10M3 10l2-6h14l2 6"/>
                <path d="M3 10a3 3 0 0 0 5 2 3 3 0 0 0 4 0 3 3 0 0 0 4 0 3 3 0 0 0 5-2M9 20v-5h6v5"/>
            </React.Fragment>
        ),
        team: (
            <React.Fragment>
                <circle cx="9" cy="8" r="3"/>
                <circle cx="17" cy="10" r="2"/>
                <path d="M3 20a6 6 0 0 1 12 0m0-5a4 4 0 0 1 6 4"/>
            </React.Fragment>
        ),
        broadcast: (
            <React.Fragment>
                <path d="M4 13v-2l13-5v12L4 13Z"/>
                <path d="m8 14 1 5h3l1-4M20 9v6"/>
            </React.Fragment>
        ),
        arrow: <path d="M5 12h14m-5-5 5 5-5 5"/>,
        check: <path d="m5 12 4 4L19 6"/>,
        telegram: (
            <path d="M21 4 3.8 10.6c-1.2.5-1.2 1.1-.2 1.4l4.4 1.4 1.7 5.1c.2.7.1 1 .8 1 .5 0 .8-.2 1-.5l2.1-2 4.4 3.2c.8.5 1.4.2 1.6-.8L22.4 6c.3-1.2-.5-1.8-1.4-2Zm-2.3 3.1-7.5 6.8-.3 3.3-1.7-5.3 9-5.6c.4-.3.8-.1.5.8Z"/>
        ),
        mail: (
            <React.Fragment>
                <rect x="3" y="5" width="18" height="14" rx="2"/>
                <path d="m4 7 8 6 8-6"/>
            </React.Fragment>
        )
    }

    return (
        <svg
            className="telegram-bots__icon"
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
        >
            {paths[name]}
        </svg>
    )
}

export default class TelegramBots extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0)
        this.previousTitle = window.document.title
        this.metaDescription = window.document.querySelector('meta[name="description"]')
        this.previousDescription = this.metaDescription && this.metaDescription.getAttribute('content')
        window.document.title = 'Telegram-боты для бизнеса — Landlix'
        if (this.metaDescription) {
            this.metaDescription.setAttribute(
                'content',
                'Разработка Telegram-ботов и Mini Apps для продаж, поддержки, записи, заказов и внутренних процессов. Интеграции с CRM, API и ИИ по вашей базе знаний.'
            )
        }
    }

    componentWillUnmount() {
        if (this.previousTitle) {
            window.document.title = this.previousTitle
        }
        if (this.metaDescription && this.previousDescription) {
            this.metaDescription.setAttribute('content', this.previousDescription)
        }
    }

    render() {
        return (
            <main className="telegram-bots" id="main-content">
                <section className="telegram-bots__hero" aria-labelledby="telegram-bots-title">
                    <div className="telegram-bots__hero-glow" aria-hidden="true"/>
                    <div className="telegram-bots__container telegram-bots__hero-grid">
                        <div className="telegram-bots__hero-copy">
                            <p className="telegram-bots__eyebrow">
                                Telegram-решения для бизнеса
                            </p>
                            <h1 id="telegram-bots-title">
                                Бот, который не просто отвечает —
                                <span> ведёт клиента к действию</span>
                            </h1>
                            <p className="telegram-bots__lead">
                                Заявки, консультации, запись, заказ и поддержка —
                                в одном диалоге. Проектируем управляемый сервис с
                                интеграциями, состоянием и понятной передачей человеку.
                            </p>
                            <div className="telegram-bots__hero-actions">
                                <a
                                    className="telegram-bots__button telegram-bots__button--primary"
                                    href="https://t.me/landlix_support_bot"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Обсудить задачу
                                    <Icon name="arrow"/>
                                </a>
                                <a
                                    className="telegram-bots__button telegram-bots__button--ghost"
                                    href={telegramEmailUrl}
                                >
                                    {publicConfiguration.supportEmail}
                                </a>
                            </div>
                            <ul className="telegram-bots__hero-notes" aria-label="Основные принципы">
                                <li>Сценарий под ваш процесс</li>
                                <li>Интеграции через API</li>
                                <li>Контроль человека</li>
                            </ul>
                        </div>

                        <div
                            className="telegram-bots__system-map"
                            role="img"
                            aria-label="Схема работы: пользователь пишет боту, бот применяет бизнес-логику, обращается к сервисам компании и передаёт результат пользователю или сотруднику"
                        >
                            <div className="telegram-bots__map-header">
                                <span>Рабочий контур</span>
                                <span className="telegram-bots__map-status">
                                    <i aria-hidden="true"/> проектируется под задачу
                                </span>
                            </div>
                            <div className="telegram-bots__map-canvas" aria-hidden="true">
                                <div className="telegram-bots__map-node telegram-bots__map-node--user">
                                    <span className="telegram-bots__map-avatar">01</span>
                                    <div>
                                        <b>Клиент</b>
                                        <small>сообщение / кнопка</small>
                                    </div>
                                </div>
                                <span className="telegram-bots__map-line telegram-bots__map-line--one"/>
                                <div className="telegram-bots__map-node telegram-bots__map-node--bot">
                                    <span className="telegram-bots__map-logo">
                                        <Icon name="telegram"/>
                                    </span>
                                    <div>
                                        <b>Telegram-бот</b>
                                        <small>диалог и состояние</small>
                                    </div>
                                </div>
                                <span className="telegram-bots__map-line telegram-bots__map-line--two"/>
                                <div className="telegram-bots__map-core">
                                    <span>Business logic</span>
                                    <b>Проверка → действие → ответ</b>
                                    <div className="telegram-bots__map-core-grid">
                                        <i/><i/><i/><i/><i/><i/>
                                    </div>
                                </div>
                                <span className="telegram-bots__map-line telegram-bots__map-line--three"/>
                                <div className="telegram-bots__map-stack">
                                    <span>CRM</span>
                                    <span>API</span>
                                    <span>DB</span>
                                    <span>AI</span>
                                </div>
                                <div className="telegram-bots__map-result">
                                    <small>Результат</small>
                                    <b>Ответ клиенту</b>
                                    <b>Задача команде</b>
                                </div>
                            </div>
                            <div className="telegram-bots__map-footer">
                                <span>События дедуплицируются</span>
                                <span>Секреты вне кода</span>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="telegram-bots__outcomes" aria-labelledby="outcomes-title">
                    <div className="telegram-bots__container">
                        <h2 id="outcomes-title" className="telegram-bots__visually-hidden">
                            Как бот проводит обращение через бизнес-процесс
                        </h2>
                        <ol className="telegram-bots__outcome-grid">
                            {businessOutcomes.map(item => (
                                <li key={item.number}>
                                    <span>{item.number}</span>
                                    <h3>{item.title}</h3>
                                    <p>{item.text}</p>
                                </li>
                            ))}
                        </ol>
                    </div>
                </section>

                <section className="telegram-bots__section" aria-labelledby="bot-types-title">
                    <div className="telegram-bots__container">
                        <div className="telegram-bots__section-heading">
                            <p className="telegram-bots__eyebrow">Типы решений</p>
                            <h2 id="bot-types-title">Один интерфейс — разные бизнес-задачи</h2>
                            <p>
                                Выбираем не шаблон бота, а подходящую архитектуру:
                                от компактного сценария до сервиса с backend,
                                ролями и несколькими интеграциями.
                            </p>
                        </div>
                        <div className="telegram-bots__type-grid">
                            {botTypes.map((item, index) => (
                                <article className="telegram-bots__type-card" key={item.title}>
                                    <div className="telegram-bots__type-top">
                                        <span className="telegram-bots__icon-box">
                                            <Icon name={item.icon}/>
                                        </span>
                                        <span className="telegram-bots__card-index">
                                            {String(index + 1).padStart(2, '0')}
                                        </span>
                                    </div>
                                    <h3>{item.title}</h3>
                                    <p>{item.text}</p>
                                    <ul>
                                        {item.tags.map(tag => <li key={tag}>{tag}</li>)}
                                    </ul>
                                </article>
                            ))}
                            <article className="telegram-bots__miniapp-card">
                                <div>
                                    <p className="telegram-bots__eyebrow">Telegram Mini App</p>
                                    <h3>Когда кнопок в чате уже недостаточно</h3>
                                    <p>
                                        Добавляем встроенный веб-интерфейс для
                                        каталога, личного кабинета, сложной формы
                                        или истории операций — с единым входом
                                        из диалога.
                                    </p>
                                </div>
                                <ul>
                                    <li>Привычный экран внутри Telegram</li>
                                    <li>Общий backend с ботом</li>
                                    <li>Адаптация под mobile и desktop</li>
                                </ul>
                            </article>
                        </div>
                    </div>
                </section>

                <section className="telegram-bots__section telegram-bots__section--ai" aria-labelledby="ai-title">
                    <div className="telegram-bots__container telegram-bots__ai-layout">
                        <div className="telegram-bots__ai-copy">
                            <p className="telegram-bots__eyebrow">AI без магии</p>
                            <h2 id="ai-title">Искусственный интеллект там, где он полезен</h2>
                            <p>
                                AI-слой можно добавить к строгому сценарию, но он
                                не заменяет правила бизнеса. Источники, допустимые
                                действия и момент передачи сотруднику задаются заранее.
                            </p>
                            <div className="telegram-bots__ai-rule">
                                <span>Принцип</span>
                                <b>Модель предлагает. Бизнес-логика проверяет.</b>
                            </div>
                        </div>
                        <ol className="telegram-bots__ai-list">
                            {aiCapabilities.map(item => (
                                <li key={item.number}>
                                    <span>{item.number}</span>
                                    <div>
                                        <h3>{item.title}</h3>
                                        <p>{item.text}</p>
                                    </div>
                                </li>
                            ))}
                        </ol>
                    </div>
                </section>

                <section className="telegram-bots__section" aria-labelledby="integrations-title">
                    <div className="telegram-bots__container telegram-bots__integration-layout">
                        <div className="telegram-bots__section-heading telegram-bots__section-heading--sticky">
                            <p className="telegram-bots__eyebrow">Интеграции</p>
                            <h2 id="integrations-title">Бот не остаётся отдельным островом</h2>
                            <p>
                                Подключаемся к системам через официальный API,
                                webhooks или отдельный защищённый сервис. Точный
                                набор зависит от доступов и возможностей выбранной платформы.
                            </p>
                        </div>
                        <dl className="telegram-bots__integration-list">
                            {integrations.map(([name, description], index) => (
                                <div key={name}>
                                    <dt>
                                        <span>{String(index + 1).padStart(2, '0')}</span>
                                        {name}
                                    </dt>
                                    <dd>{description}</dd>
                                    <i aria-hidden="true"><Icon name="arrow"/></i>
                                </div>
                            ))}
                        </dl>
                    </div>
                </section>

                <section className="telegram-bots__section telegram-bots__section--process" aria-labelledby="process-title">
                    <div className="telegram-bots__container">
                        <div className="telegram-bots__section-heading">
                            <p className="telegram-bots__eyebrow">Процесс</p>
                            <h2 id="process-title">От карты диалога до работающего сервиса</h2>
                        </div>
                        <ol className="telegram-bots__timeline">
                            {processSteps.map((item, index) => (
                                <li key={item.stage}>
                                    <div className="telegram-bots__timeline-marker">
                                        <span>{String(index + 1).padStart(2, '0')}</span>
                                    </div>
                                    <div className="telegram-bots__timeline-card">
                                        <small>{item.stage}</small>
                                        <h3>{item.title}</h3>
                                        <p>{item.text}</p>
                                    </div>
                                </li>
                            ))}
                        </ol>
                    </div>
                </section>

                <section className="telegram-bots__section telegram-bots__section--safety" aria-labelledby="safety-title">
                    <div className="telegram-bots__container telegram-bots__safety-layout">
                        <div>
                            <p className="telegram-bots__eyebrow">Production-подход</p>
                            <h2 id="safety-title">Надёжность закладывается в сценарий</h2>
                            <p>
                                Объём мер зависит от данных и критичности процесса.
                                На старте фиксируем риски, границы автоматизации и
                                способ восстановления после ошибки.
                            </p>
                        </div>
                        <ul className="telegram-bots__safety-list">
                            {safeguards.map(item => (
                                <li key={item}>
                                    <span><Icon name="check"/></span>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                </section>

                <section className="telegram-bots__cta" aria-labelledby="telegram-cta-title">
                    <div className="telegram-bots__container telegram-bots__cta-inner">
                        <div>
                            <p className="telegram-bots__eyebrow">Следующий шаг</p>
                            <h2 id="telegram-cta-title">Опишите процесс, который хотите упростить</h2>
                            <p>
                                Мы уточним сценарий, пользователей и нужные
                                интеграции, после чего предложим реалистичный
                                состав первой версии.
                            </p>
                        </div>
                        <div className="telegram-bots__cta-actions">
                            <a
                                href="https://t.me/landlix_support_bot"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="telegram-bots__contact-card telegram-bots__contact-card--telegram"
                            >
                                <span><Icon name="telegram"/></span>
                                <div>
                                    <small>Написать в Telegram</small>
                                    <b>@landlix_support_bot</b>
                                </div>
                                <Icon name="arrow"/>
                            </a>
                            <a
                                href={telegramEmailUrl}
                                className="telegram-bots__contact-card"
                            >
                                <span><Icon name="mail"/></span>
                                <div>
                                    <small>Отправить описание</small>
                                    <b>{publicConfiguration.supportEmail}</b>
                                </div>
                                <Icon name="arrow"/>
                            </a>
                        </div>
                    </div>
                </section>
            </main>
        )
    }
}
